import { Card } from 'common/api/e-comm/models/Card';
import { emptyUniversalBrand, UniversalBrand } from 'common/api/models/UniversalBrand';

export const getCardName = (card: Card, brand: UniversalBrand = emptyUniversalBrand) => {
    return card.name || brand.name;
};
